import { render, staticRenderFns } from "./ReplyListComp.vue?vue&type=template&id=ff9a4232&scoped=true"
import script from "./ReplyListComp.vue?vue&type=script&lang=ts"
export * from "./ReplyListComp.vue?vue&type=script&lang=ts"
import style0 from "./ReplyListComp.vue?vue&type=style&index=0&id=ff9a4232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9a4232",
  null
  
)

export default component.exports